import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useI18n } from '../../context/occ/hooks/use-i18n';
import { Attribute as AttributeComponent } from '../attribute/attribute';
import { getHeroAttributesForShowtime, getStandardAttributesForShowtime } from './utils';
const b = bemClassBuilder('v-attribute-list');
export const AttributeList = observer(props => {
    const i18n = useI18n();
    const { attributes, className, heading, showDetails, iconCdnOptions } = props;
    const heroAttributes = getHeroAttributesForShowtime(attributes, i18n);
    const standardAttributes = getStandardAttributesForShowtime(attributes, i18n);
    const sortedAttributes = heroAttributes.concat(standardAttributes);
    return (_jsxs("ul", { className: b.block({ showDetails }, className), children: [heading && heading.length > 0 && attributes.length > 0 && (_jsx("li", { className: b.element('heading'), children: heading })), sortedAttributes.map(attribute => (_jsx("li", { className: b.element('item'), children: _jsx(AttributeComponent, { attribute: attribute, showDetails: showDetails, cdnOptions: iconCdnOptions }) }, attribute.id)))] }));
});
AttributeList.displayName = 'AttributeList';
//# sourceMappingURL=attribute-list.js.map